import React from 'react';
import MobileHead from './MobileHead';
import MobileMenu from './MobileMenu';
import MobileList from './MobileList';
import HeaderProfilePopupContent from '../../../components/headerProfilePopup/headerProfilePopupContent';
import Language from '../desktop/Language';
import { HEADER_ITEM_IDS } from '../../../../constants/HeaderItemIds';
import { getSectionFromUrl } from '../../../../utilites/util';
import Consumers from '../../../../constants/Consumers';
import Languages from '../../../../constants/Languages';

interface Props {
  header: any;
  showMenuItems: (item: any, isLogin: boolean) => {};
  numberOfOrderItems: number;
  menuState: {
    items: object[];
    visible: boolean;
    isLogin: boolean;
  };
  hideSubmenuItems: () => {};
  changeLanguage: (lang: string) => void;
  closeMenu: () => void;
  openMenu: () => void;
  showLoginMenu: (name: string) => void;
  isLogin: boolean;
  user: {
    isLoggedIn: boolean;
    lastName: string;
    firstName: string;
    email: string;
    numberOfOrderItems: number;
  };
  section: string;
  language: string;
}

const MobileHeader: React.FC<Props> = (props: any) => {
  const {
    header,
    numberOfOrderItems,
    hideSubmenuItems,
    menuState,
    showMenuItems,
    showLoginMenu,
    user,
    isLogin,
    openMenu,
    closeMenu,
    section,
    language,
  } = props;

  // profile view has 2 items in menu, 3 and 4, and we need to know if we are in profile view
  const isProfileView = !!menuState.items.filter(
    (item: any) => item.id === HEADER_ITEM_IDS.SETTINGS || item.id === HEADER_ITEM_IDS.LOGOUT
  ).length;
  const isConsumer = getSectionFromUrl() === Consumers.PRIVATE_CONSUMER;

  return Object.keys(header).length ? (
    <div id="mobile-menu">
      <MobileHead
        menuVisibility={false}
        showLogin={isLogin}
        isMenuOpen={menuState.isMenuOpen}
        isLoggedIn={user.isLoggedIn}
        showLoginMenu={showLoginMenu}
        numberOfOrderItems={numberOfOrderItems}
        openMenu={openMenu}
        closeMenu={closeMenu}
        section={section}
      />
      <MobileMenu isMenuOpen={menuState.isMenuOpen}>
        <div className={'container mb-4 mt-2'}>
          {isProfileView ? (
            <HeaderProfilePopupContent item={menuState} hideSubmenu={hideSubmenuItems} />
          ) : (
            <>
              {!menuState.visible && (
                <>
                  <div className={'ps-4 d-inline-block'}>
                    <Language activeLanguage={language} changeLanguage={props.changeLanguage} />
                  </div>
                  {isConsumer && language === Languages.SR && (
                    <div className={'float-end me-3 mt-2 pe-3 d-inline-block'}>
                      <a
                        style={{ color: '#002340' }}
                        className="no-child list-item first-level"
                        href="https://www.yettel.rs/sr/privatni/podrska"
                      >
                        <span> Kontakt i Podrška </span>
                      </a>
                    </div>
                  )}
                </>
              )}
              <MobileList
                selectedItems={menuState}
                selectedItemsVisible={menuState.visible}
                isLogin={true}
                activeItem={header.item}
                links={header.genericLinks}
                numberOfOrderItems={numberOfOrderItems}
                showMenuItems={showMenuItems}
                hideSubmenu={hideSubmenuItems}
                section={section}
              />
            </>
          )}
        </div>
      </MobileMenu>
    </div>
  ) : null;
};

export default MobileHeader;
